import React from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./confirmOrder.module.less";
import { useConfirmOrder } from "./hooks/useConfirmOrder";

const ConfirmOrder = () => {
    const [searchParams] = useSearchParams();
    const skuCode = searchParams.get("skuCode");
    if (!skuCode) {
        return <div>商品不存在</div>;
    }
    const { confirmOrderInfo, paying, submitOrder } = useConfirmOrder();
    return (
        <div className={styles.wraper}>
            <div className={styles.product}>
                <img className={styles.productImg} src="{ confirmOrderInfo?.coverPic }" />
                <div className={styles.productInfo}>
                    <div className={styles.productName}>{confirmOrderInfo?.title || "商品标题"}</div>
                    <div className={styles.productDesc}>{confirmOrderInfo?.subTitle || "副标签"}</div>
                    <div className={styles.productPrice}>价格 ¥{confirmOrderInfo?.salePrice}</div>
                </div>
            </div>
            <div className={styles.orderInfo}>
                <div className={styles.orderInfoItem}>
                    <div className={styles.orderInfoItemTitle}>商品金额</div>
                    <div className={styles.orderInfoItemValue}>{confirmOrderInfo?.salePrice}</div>
                </div>
            </div>
            <div className={styles.payTypesInfo}>
                <div className={styles.payTypesInfoTitle}>支付方式</div>
                <div className={styles.payTypeItem}>
                    <div className={styles.payType + " " + styles.wechat}>微信支付</div>
                    <div className={styles.payTypeCheckbox + " " + styles.checked}></div>
                </div>
            </div>
            <div className={styles.footer}>
                <div className={styles.totalPrice}><span className={styles.quantityText}>
                    共{confirmOrderInfo?.totalCount || 1}件</span>合计：<span className={styles.totalPriceValue}>{confirmOrderInfo?.totalAmount}</span>
                </div>
                <div className={styles.confirmButton} onClick={() => paying ? null : submitOrder()}>
                    {paying ? "支付中..." : "立即支付"}
                </div>
            </div>
        </div>
    );
};

export default ConfirmOrder;